import React from "react";
import {
	Container,
	Row,
	Col,
	Card,
	Button,
	ButtonGroup,
	CardTitle,
	CardBody,
} from "reactstrap";
import "../styles/carousel.css";
import dayjs from "dayjs";

import events from "../data/events.json";
function Features() {
	return (
		<Container fluid>
			{events
				.sort((a, b) => dayjs(b.date).valueOf() - dayjs(a.date).valueOf())
				.map((event, i) => {
					return (
						<Row style={{ margin: `8px 8px 16px 8px` }}>
							<Col xs={12} sm={12}>
								<Card>
									<CardBody>
										<CardTitle>
											<h3>{event.title}</h3>
										</CardTitle>

										<Row>
											<Col md={5}>
												<img
													src={`${process.env.PUBLIC_URL}/${event.image}`}
													alt="primary"
													className="img-responsive img-thumbnail main-img"
												/>
											</Col>
											<Col md={7}>
												<p>
													<strong>
														{dayjs(event.date).format("MM/DD/YYYY")}
														{": "}
													</strong>
													{event.text}
												</p>
												{event.actions && (
													<div>
														<ButtonGroup>
															{event.actions.map(({ text, ...others }, i) => (
																<Button outline size="sm" {...others}>
																	{text}
																</Button>
															))}
														</ButtonGroup>
													</div>
												)}
											</Col>
										</Row>
									</CardBody>
								</Card>
							</Col>
						</Row>
					);
				})}
		</Container>
	);
}
export default Features;
